import styled from 'styled-components';

export const TaxesModalContainer = styled.div`
  * {
    line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  }
`;

export const TaxesModalSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px dotted ${({ theme }) => theme.kallisto.color.common.black[100]};
  margin-bottom: 10px;
`;

export const TaxesModalAllIncludedSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const Separator = styled.hr`
  margin: 8px 0;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.kallisto.color.common.black[100]};
`;
